import { PureComponent } from "react";
import Modal from "react-modal";
import { MODAL_BACKGROUND } from "/constants/z-index";
import ModalContentComponent from "./modal-content/modal-content-component";
import onClickOutside from "react-onclickoutside";
import { componentStyles } from "./modal-with-signup-component.scss";

import XIcon from "static/svg/x.svg";

export default class ModalWithSignupComponent extends PureComponent {
  componentDidMount() {
    Modal.setAppElement("body");
  }

  render() {
    const { onCloseModal } = this.props;
    return (
      <Modal {...this.props}>
        <div className="close-button" onClick={onCloseModal}>
          <XIcon />
        </div>
        <ModalContentComponent {...this.props} />
        <style jsx>{componentStyles}</style>
      </Modal>
    );
  }
}

ModalWithSignupComponent.defaultProps = {
  footerText: "",
  shouldCloseOnEsc: true,
  shouldCloseOnOverlayClick: true,
  style: {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.75)",
      zIndex: `${MODAL_BACKGROUND}`
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      transform: "translate(-50%, -50%)",
      padding: "0",
      border: "none",
      display: "flex",
      flexDirection: "column",
      backgroundColor: "transparent",
      minHeight: "630px",
      minWidth: "960px",
      overflow: "hidden",
      borderRadius: "16px"
    }
  },
  isOpen: false
};
